import ESG1 from "@assets/KPMG/ESG/esg1.png";
import ESG2 from "@assets/KPMG/ESG/esg2.png";
import ESG3 from "@assets/KPMG/ESG/esg3.png";
import ESG4 from "@assets/KPMG/ESG/esg4.png";
import ESG5 from "@assets/KPMG/ESG/esg5.png";
import ESG6 from "@assets/KPMG/ESG/esg6.png";

export const mockData: any = {
  toolsList: [
    {
      icon: ESG1,
      label: "Risk Assessment",
      title: "KPMG SMART(Sustainability Measurement and Reporting Tool)",
      description:
        "KPMG SMART is a solution that simplifies sustainability management and reporting, essential for business success and a sustainable future",
      sector: "Sector Agnostic",
    },
    {
      icon: ESG2,
      label: "Climate Assessment",
      title: "KPMG ESG Risk Tool For testing credit portfolios",
      description:
        "Analyze your organization's portfolio's ESG risks and available opportunities",
      sector: "Banking and Finance",
    },
    {
      icon: ESG3,
      label: "Climate Assessment",
      title: "KPMG CLIMAX Tool",
      description:
        "Get deep insights on risks your loan portfolio has on the climate",
      sector: "Corporates and Companies",
    },
    {
      icon: ESG4,
      label: "Due Diligence",
      title: "KPMG ESG Due Diligence Tool for PE",
      description:
        "A special ESG matrix developed to analyze investments to help PE investors",
      sector: "Corporates and Companies",
    },
    {
      icon: ESG5,
      label: "Analytics",
      title: "KPMG Sofy Suite",
      description:
        "A cloud-based analytics platform for risk management, compliance, tax, finance, data, and strategy, supply chain sustainability",
      sector: "Sector Agnostic",
    },
    {
      icon: ESG6,
      label: "Material Assessment",
      title: "KPMG Trust-Based Materiality Tool",
      description:
        "We provide in-depth analysis on the material sustainability issues your organization might face",
      sector: "Sector Agnostic",
    },
  ],
};
